var cilItalic = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M16,496H496V16H16ZM48,48H464V464H48Z' class='ci-primary'/><polygon fill='var(--ci-primary-color, currentColor)' points='200 143.998 244.442 143.998 202.442 367.998 152 367.998 152 399.998 312 399.998 312 367.998 267.558 367.998 309.558 143.998 360 143.998 360 111.998 200 111.998 200 143.998' class='ci-primary'/>"];

export { cilItalic };

